import { SearchResultListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/SearchResultListItem";
import { getSortValueCustomer } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-menu.utils";
import { CustomerRow, SearchResultItem } from "@/components/layout/Navbar/ApplicationSearch/application-search.types";
import { routes } from "@/routes";
import { generatePath } from "@/routes/routes.utils";

type Props = {
    data: CustomerRow;
    onClick: (item: SearchResultItem) => void;
    isRecentSearch?: boolean;
    className?: string;
};

export const CustomerListItem = (props: Props) => {
    const { data } = props;

    // Constrain data to CustomerRow as it can be CustomerExtendedRow
    const customerRow: CustomerRow = {
        CustomerNumber: data.CustomerNumber,
        Name: data.Name,
        City: data.City,
    };

    const item: SearchResultItem = {
        type: "customer",
        data: customerRow,
        sortValue: getSortValueCustomer(customerRow),
    };

    return (
        <SearchResultListItem
            label={[data.Name, data.City].join(" - ")}
            chip={data.CustomerNumber}
            title={"Customer"}
            // @ts-expect-error FIXME: link can be undefined
            url={generatePath(routes.customerDetail, {
                params: {
                    customerNumber: data.CustomerNumber,
                },
            })}
            icon={"lely-icon-human"}
            onClick={() => props.onClick(item)}
            isRecentSearch={props.isRecentSearch}
            className={props.className}
        />
    );
};
